import { createAction } from 'redux-actions';

const setUserList = createAction('SET_USER_LIST');
const setBenutzer = createAction('SET_BENUTZER');

export {
    setUserList,
    setBenutzer
};